import { CourseId } from 'modules/courses/courses/types/course-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from '@systemeio/util'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { getLightCourseCurriculumPath } from '../light-course-api'
import { LightCourseCurriculumInterface } from '../light-course-interface'

export function useLightCourseCurriculum(id?: CourseId, isFetchAllowed = true) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, LightCourseCurriculumInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    () => {
      if (!user || !id) return
      return [
        getLightCourseCurriculumPath(id),
        RequestModuleEnum.MembershipLightCourse,
        RequestModuleEnum.MembershipLightCourseCurriculum,
      ]
    },
    fetcher,
    undefined,
    isFetchAllowed,
  )
}
